import { c as _c } from "react/compiler-runtime";
import type { SxProps } from '@mui/material';
import Box from '@mui/material/Box';

// this is for a future refactor
// it is a much nicer way to handle this
// type Variant = 'normal' | 'compact';
type Spacing = 'some' | 'none' | 'compact';
export const BoxHorizontal = t0 => {
  const $ = _c(6);
  const {
    children,
    sx,
    spacing: t1
  } = t0;
  const spacing = t1 === undefined ? "some" : t1;
  const gap = spacing === "some" ? "10px" : 0;
  let t2;
  if ($[0] !== gap || $[1] !== sx) {
    t2 = {
      gap,
      flexDirection: "row",
      display: "flex",
      ...sx
    };
    $[0] = gap;
    $[1] = sx;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== t2) {
    t3 = <Box sx={t2}>{children}</Box>;
    $[3] = children;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};